import React from 'react'

import i18n from 'live/services/i18n'

import { RowDiv } from './styles'

export interface ILivePaginationProps {
    type: 'live'
    totalItems: number
    showingItems: number
    label?: string
    /**
     * onPerPageChange will return the new max itens per page on list
     */
    onPerPageChange?: () => void
}

export const LivePagination: React.FC<ILivePaginationProps> = ({
    showingItems,
    totalItems,
    onPerPageChange,
    label
}) => {
    const moreItems = (): number => {
        const showMore = totalItems - showingItems
        if (showMore > showingItems) {
            return showingItems
        } else {
            return showMore
        }
    }

    return (
        <RowDiv>
            <div>
                {i18n('Showing')} {showingItems > totalItems ? totalItems : showingItems} {i18n(label).toLowerCase()} {' '} {i18n('of')} {totalItems}
                
            </div>
            {showingItems < totalItems && (
                <button className="btn btn-primary" onClick={onPerPageChange}>
                    <i className="fas fa-arrow-circle-down"></i> {i18n('Load more')} {moreItems()}
                </button>
            )}
        </RowDiv>
    )
}
